module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/staff/staff.html
// module id = 477
// module chunks = 0